import { makeStyles } from '@material-ui/core/styles';
import { SortableContainer } from 'react-sortable-hoc';
import Table from 'components/CncUI/Table';
import Row from './Row';

const useStyles = makeStyles(({ palette }) => ({
  empty: {
    '& .cncui-table-cell': {
      textAlign: 'center',
      height: '5em',
      fontStyle: 'italic',
      color: palette.cncUI.default.primary,
    },
  },
}));

const Body = props => {
  const classes = useStyles();
  const { items, mappings, multiple, amountType, error } = props;
  const { onRemove, onChange, onKey, isCurrencyEnabled } = props;

  return (
    <Table.Body>
      {items.map((item, index) => (
        <Row
          key={onKey(`table-row-${index}`)}
          index={index}
          value={item}
          sortIndex={index}
          mappings={mappings}
          form={items}
          amountType={amountType}
          multiple={multiple}
          error={error}
          onChange={onChange}
          onRemove={onRemove}
          isCurrencyEnabled={isCurrencyEnabled}
        />
      ))}
      {items.length === 0 && (
        <Table.Row className={classes.empty}>
          <Table.Cell align="center" colSpan={multiple ? 8 : 6}>
            No bank account added yet
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  );
};

export default SortableContainer(Body);
